import React from 'react'
import {Flex} from '/app/src/component'
import {connect} from 'react-redux';
import ConversationSelector from '/app/src/model/Conversation/selector'
import ArchivedOptions from '/app/src/layout/Dashboard/RightPanel/Conversation/Archived'

class ItemPreview extends React.Component {

    render(){
        if(!this.props.ticket.size) return ''
        let ticket = this.props.ticket.getIn(['info', 'payload'])
        if(ticket) ticket = ticket.toJS()
        if(!ticket) return null;
        return(
            <Flex column grow w='100%'>
                <ArchivedOptions room={ticket.room}/>
            </Flex>
         )
    }
}

function mapStateToProps(state, ownProps) {
    let room = ownProps.match.params.id
    let ticket = ConversationSelector.getByRoom(state, room)
    return {
        ticket: ticket
    };
}

export default connect(mapStateToProps)(ItemPreview);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/History/ItemPreview.js